var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 63,
    viewBox: "0 0 71 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.63 6.72C21.76 6.56 18.83 7.72 18.46 11.58C18.35 12.75 18.82 14.22 19.35 15.92C19.66 16.9 19.99 17.91 20.16 18.78C21.47 25.32 19.45 26.94 19.31 27.05C18.53 27.48 18.23 28.46 18.63 29.26C18.92 29.85 19.52 30.19 20.13 30.19C20.38 30.19 20.64 30.13 20.88 30.01C21.34 29.78 25.33 27.49 23.45 18.12C23.24 17.07 22.89 15.97 22.55 14.91C22.21 13.85 21.75 12.4 21.8 11.9C21.95 10.33 22.73 10.06 23.34 10.06C24.26 10.16 25.07 9.46 25.16 8.53C25.24 7.61 24.56 6.8 23.63 6.72Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.11 4.94C45.24 4.78 42.31 5.94 41.94 9.8C41.83 10.97 42.3 12.44 42.83 14.14C43.14 15.12 43.47 16.13 43.64 17C44.95 23.54 42.93 25.16 42.79 25.27C42.01 25.7 41.71 26.68 42.11 27.48C42.4 28.07 43 28.41 43.61 28.41C43.86 28.41 44.12 28.35 44.36 28.23C44.82 28 48.81 25.71 46.93 16.34C46.72 15.29 46.37 14.19 46.03 13.13C45.69 12.07 45.23 10.62 45.28 10.12C45.43 8.55 46.2 8.28 46.82 8.28C47.74 8.38 48.55 7.68 48.64 6.75C48.72 5.83 48.04 5.01 47.11 4.94Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.42 0.0199978C35.14 -0.0100022 33.71 -0.110002 32.34 1.02C31.09 2.06 30.37 3.75 30.2 6.04C30.1 7.41 30.55 9.28 31.07 11.45C31.39 12.77 31.71 14.14 31.9 15.35C33.29 24.64 31.03 27.02 30.88 27.17C30.17 27.7 29.99 28.7 30.49 29.44C30.81 29.92 31.34 30.19 31.89 30.19C32.21 30.19 32.53 30.1 32.82 29.91C33.53 29.44 36.97 26.49 35.22 14.85C35.02 13.5 34.68 12.06 34.34 10.67C33.94 9.01 33.5 7.14 33.56 6.28C33.72 4.11 34.49 3.36 35.04 3.36C35.95 3.36 36.79 2.8 36.9 1.88C37.01 0.959998 36.34 0.129998 35.42 0.0199978Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68001 41.93C1.14001 41.93 0.640007 42.19 0.320007 42.63C0.0100065 43.07 -0.0799934 43.63 0.0900066 44.14L3.44001 54.2C3.67001 54.88 4.31001 55.35 5.03001 55.35H65.41C66.13 55.35 66.77 54.89 67 54.2L70.35 44.14C70.52 43.63 70.43 43.07 70.12 42.63C69.81 42.19 69.3 41.93 68.76 41.93H1.68001ZM66.44 45.28L64.2 51.99H6.24001L4.01001 45.28H66.44Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44 58.7H0V62.05H70.44V58.7Z",
    fill: "#075E76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.44,
    height: 62.05,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatters);
export default __webpack_public_path__ + "static/media/platters.fa5f8e61ad0a7f494b72b46b8f4ff0e7.svg";
export { ForwardRef as ReactComponent };